import type { SortType } from '@features/artwork/artworks-sort';

export const defaultSortParams = {
  column: 'year',
  order: 'desc',
};

export const artworksSortOptions: {
  text: string;
  value: SortType;
}[] = [
  {
    text: 'Newest',
    value: {
      column: 'year',
      order: 'desc',
    },
  },
  {
    text: 'Oldest',
    value: {
      column: 'year',
      order: 'asc',
    },
  },
  {
    text: 'Artwork Title A-z',
    value: {
      column: 'name_english',
      order: 'asc',
    },
  },
  {
    text: 'Artwork Title Z-a',
    value: {
      column: 'name_english',
      order: 'desc',
    },
  },
];
